import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';
import { PillsList } from '@hivebrite/design-system/PillsList';

const CategoriesList = ({ categories, networkCategoryIds = [] }) => {
  const fileCategories = (categories || []).filter((category) =>
    (networkCategoryIds || []).includes(category.id),
  );

  if (!fileCategories.length) {
    return null;
  }

  return (
    <Box mt={2} alignSelf="flex-end" data-testid="categories-list">
      <PillsList
        dataTestId="category-wrapper"
        pills={fileCategories}
        seeMoreLabel={__('See More')}
        seeLessLabel={s__('Tags|See less')}
      />
    </Box>
  );
};

CategoriesList.propTypes = {
  categories: PropTypes.array.isRequired,
  networkCategoryIds: PropTypes.array,
};

export default CategoriesList;
